// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3mTjq","cell":"ColumnAccessor_cell__3UZSP","firstCellAccent":"ColumnAccessor_firstCellAccent__1CmeL"};